import { Sheet, Typography, Stack, Button, IconButton } from '@mui/joy';
import { TelegramLogo, X } from '@phosphor-icons/react';
import { useState } from 'react';

export const TG_INVITE_URL = 'https://t.me/+3y2a7TIAQNNjZjgy';
export const DISMISS_KEY = 'apex_tg_invite_dismissed';

/**
 * Приглашение в закрытый чат для тех, кто взял годовой доступ.
 *
 * Кому показывать, решает `subscription.period === '12 мес'` — эту строку
 * главная уже получает с бэкенда, и она считается от реальной длительности
 * инвойса (product_period_label: всё от 360 дней). Проверять по названию
 * тарифа было бы неверно: в проде есть годовой клиент со старым тарифом
 * `plan1` (его бы пропустили) и полугодовой с тарифом `grand_12m`
 * (попал бы зря).
 *
 * Само наличие `subscription` означает активную подписку — значит человек
 * уже нажал «Активировать».
 */
export function shouldShowTgInvite(subscription) {
    return subscription?.period === '12 мес';
}

export default function TelegramInviteBanner({ subscription, sx }) {
    const [hidden, setHidden] = useState(() => {
        try { return localStorage.getItem(DISMISS_KEY) === '1'; } catch { return false; }
    });

    if (hidden || !shouldShowTgInvite(subscription)) return null;

    const dismiss = () => {
        try { localStorage.setItem(DISMISS_KEY, '1'); } catch { /* приватный режим — просто скроем на сессию */ }
        setHidden(true);
    };

    return (
        <Sheet
            variant="soft"
            sx={{
                position: 'relative',
                borderRadius: 'md',
                border: '1px solid rgba(218,119,86,0.35)',
                bgcolor: (theme) => theme.palette.mode === 'dark' ? 'rgba(218,119,86,0.08)' : '#FFF8F0',
                p: 2,
                ...sx,
            }}
        >
            <IconButton
                size="sm"
                variant="plain"
                color="neutral"
                onClick={dismiss}
                aria-label="Скрыть приглашение"
                sx={{ position: 'absolute', top: 6, right: 6, minHeight: 28, minWidth: 28 }}
            >
                <X size={15} />
            </IconButton>

            <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.75, pr: 4 }}>
                <TelegramLogo size={18} color="#DA7756" weight="duotone" />
                <Typography level="title-sm" sx={{ color: '#B84C31' }}>
                    Закрытый чат APEX
                </Typography>
            </Stack>

            <Typography level="body-sm" color="neutral" sx={{ mb: 1.5 }}>
                Годовой доступ открывает вход в наш чат: разборы, вопросы и общение
                с теми, кто тоже готовится к USMLE.
            </Typography>

            <Button
                component="a"
                href={TG_INVITE_URL}
                target="_blank"
                rel="noopener noreferrer"
                size="sm"
                variant="solid"
                startDecorator={<TelegramLogo size={16} weight="fill" />}
                sx={{ bgcolor: '#B84C31', '&:hover': { bgcolor: '#9E3F28' } }}
            >
                Вступить в чат
            </Button>
        </Sheet>
    );
}
